module.exports = __webpack_public_path__ + "static/media/LogoExitFund.3d12dd21.svg";